export const playlists = [
  {
    id: 1,
    name: "Synthwave Classics",
    songs: 24,
    cover: "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=200&h=200&fit=crop",
    description: "The best of synthwave music",
    songIds: [1, 4, 5]
  },
  {
    id: 2,
    name: "Retro Hits",
    songs: 18,
    cover: "https://images.unsplash.com/photo-1571330735066-03aaa9429d89?w=200&h=200&fit=crop",
    description: "Nostalgic hits from the past",
    songIds: [2, 3, 5]
  },
  {
    id: 3,
    name: "Chill Vibes",
    songs: 32,
    cover: "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=200&h=200&fit=crop",
    description: "Relaxing electronic music",
    songIds: [3, 1, 2]
  }
];
